
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderComponent',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      isOverlayActive: 'ui/isOverlayActive',
      activeFilter: 'ui/getActiveFilter'
    }),
    navigateBack() {
      return `/line-up${this.activeFilter ? `?stage=${this.activeFilter}` : ''}`;
    }
  },

  methods: {
    toggleNavOverlay() {
      this.$store.commit('ui/toggleOverlay', !this.isOverlayActive);
    }
  }
};
